<!-- eslint-disable -->
<template lang="pug">
    .notification
        .notification-background(@click="handleCloseModal")
        .notification-box(@click.stop role="dialog" aria-modal="true")
            .notification-header
                .notification-title {{ $i18n.t('common.common_activate_paid_tariff_now') }}

            .notification-body
                .notification-row-wrapper
                    p.notification-message {{ tariffName }}
                    p.notification-message {{ $i18n.t('trainer.trainer_main_bonusGames') + ': ' + bonusGamesString }}
                    p.notification-message {{ $i18n.t('templates.template_form_selectedCourses') + ': ' + coursesNamesString }}
                    p.notification-message(v-if="chargedSumLabel") {{ chargedSumLabel }}
            .notification-footer
                .notification-footer-wrapper
                    cs-button(
                        pattern="primary-outline"
                        color="blue"
                        @click="handleCloseModal"
                        :disabled="submitting"
                    ) {{ $i18n.t('common.common_button_cancel') }}
                    cs-button(
                        @click="confirmActivation"
                        :disabled="submitting"
                    ) {{ $i18n.t('common.common_activate_paid_tariff_now_confirm') }}
</template>

<script>
    /*eslint-disable*/
    import { mapState } from 'vuex';
    import CsButton from '@/elements/CsButton.vue';
    import CourseApi from '@/api/course';
    import TariffsApi from '@/api/tariffs/tariffs';

    const MENTAL_TYPE = 'mental-arithmetic';
    const MENTAL_IDS = [2, 3, 4, 5, 6, 7, 8, 19];
    const BASIC_TARIFF_ID = 2;
    const BONUS_GAMES_PRICE = 500;

    export default {
        components: { CsButton },
        props: {
            tariff: {
                type: Object,
                default: null,
            },
        },
        data() {
            return {
                submitting: false,
                courses: [],
            };
        },
        mounted() {
            this.getCourses();
        },
        methods: {
            getCourses() {
                if (this.courses.length) return;
                CourseApi.getCoursesForTariff()
                    .then(data => {
                        const nonMental = Object.values(data).filter(c => c.type !== MENTAL_TYPE && c.id !== 16);
                        nonMental.push({
                            id: '__MENTAL__',
                            name: 'Ментальная арифметика',
                            type: MENTAL_TYPE,
                        });
                        this.courses = nonMental;
                    })
                    .catch((e) => {
                        console.log(e);
                        this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                    });
            },
            handleCloseModal() {
                if (this.submitting) return;
                this.$emit('close');
            },
            async confirmActivation() {
                if (this.submitting) return;
                this.submitting = true;
                try {
                    const data = await TariffsApi.activatePaidNow();
                    this.$toasted.success(this.$i18n.t('common.common_activate_paid_tariff_now_success', {
                        sum: data.chargedSum,
                    }));
                    await this.$store.dispatch('setUserByToken');
                    this.$emit('close');
                } catch (err) {
                    console.error('Activate paid tariff now error', err);
                } finally {
                    this.submitting = false;
                }
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            changeRequest() {
                return this.user.school && this.user.school.changeTariffRequest
                    ? this.user.school.changeTariffRequest
                    : {};
            },
            tariffName() {
                const tariffId = this.changeRequest.nextTariffId;
                if (!tariffId) return '';
                return this.$i18n.t(`billing.billing_tariff_${tariffId}`);
            },
            bonusGamesString() {
                if (this.changeRequest.isBonusGameActive) {
                    return this.$i18n.t('progress.progress_preview_statusOn');
                }
                return this.$i18n.t('progress.progress_preview_statusOf');
            },
            coursesNamesString() {
                const idsObj = this.changeRequest.coursesIds;
                if (!idsObj || typeof idsObj !== 'object') return '';

                const ids = Object.values(idsObj)
                    .map(Number)
                    .filter(Boolean);
                if (!ids.length) return '';

                const names = [];
                this.courses.forEach(c => {
                    if (ids.includes(c.id)) names.push(c.name);
                });

                if (ids.some(id => MENTAL_IDS.includes(id)) && !names.includes('Ментальная арифметика')) {
                    names.push('Ментальная арифметика');
                }

                return names.join('; ');
            },
            chargedSum() {
                if (!this.tariff || this.tariff.price === undefined || this.tariff.price === null) {
                    return null;
                }

                const now = new Date();
                const daysInMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
                const daysCoefficient = 1 - (now.getDate() - 1) / daysInMonth;
                const bonus =
                    Number(this.tariff.id) === BASIC_TARIFF_ID && this.changeRequest.isBonusGameActive
                        ? BONUS_GAMES_PRICE
                        : 0;

                return Math.round((Number(this.tariff.price) + bonus) * daysCoefficient * 100) / 100;
            },
            chargedSumLabel() {
                if (this.chargedSum === null || this.chargedSum === undefined) return '';
                const sum = this.chargedSum;
                return this.$i18n.t('common.common_activate_paid_tariff_now_sum', {
                    sum: sum + ' ' + this.$i18n.tc('olympiads.olympiads_olympiadForm_rubles', sum),
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .notification {
        position: fixed;
        inset: 0;
        z-index: $z-index-modal;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px;
    }

    .notification-background {
        position: absolute;
        inset: 0;
        background-color: rgba($x-color-black, $opacity-default-modal-background);
    }

    .notification-box {
        position: relative;
        width: 100%;
        max-width: 340px;
        max-height: 90dvh;
        display: grid;
        grid-template-rows: auto 1fr auto;

        overflow: hidden;
        box-sizing: border-box;
        border-radius: $border-radius-20;
        background-color: $x-color-white;
        box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
        padding: 0;

        @include media($md) {
            max-width: 600px;
        }
    }

    .notification-header {
        background: $x-color-white;
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        padding: 20px 24px 14px;
    }
    .notification-title {
        font-weight: 600;
        font-size: 22px;
        line-height: 1.2;
        text-align: center;
    }

    .notification-body {
        min-height: 0;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        padding: 16px 24px;
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .notification-footer {
        background: $x-color-white;
        border-top: 1px solid rgba(0, 0, 0, 0.06);
        padding: 12px 24px 18px;
    }
    .notification-footer-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 12px;
    }

    .notification-row-wrapper {
        display: block;
    }
    .notification-message {
        margin: 0 0 8px;
        line-height: 1.4;
    }
</style>
